/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import InfiniteScroll from "react-infinite-scroll-component";
// import ContentItem from "../../components/ContentItem";
import NumberFormat from 'react-number-format';

// import Modal from "react-responsive-modal";

class MyCash extends Component {
  state = {
    gotoPage: 1,
    pageCount: 1,
    pageSize: 10,
    dataList: [],
    cardRegShow: false,
    cardListOpen: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getData = async (gotoPage) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getDataApi(gotoPage);
      const intReturn = result.data[0].intReturn;
      const pageCount = result.data[0].pageCount;
      const con = result.data[0].con;
      const cash = result.data[0].cash;
      const dataList = result.data[0].listData;
      //console.log(con)

      if (this._isMounted) {
        if (intReturn === 0) {
          if (con > 0) {
            //console.log('con > 0')
            this.setState({
              gotoPage: gotoPage,
              pageCount: pageCount,
              con: con,
              cash: cash,
              dataList: dataList,
              hasMore: pageCount < gotoPage ? false : true,
            });
          } else {
            //console.log('con < 0')
            this.setState({
              gotoPage: 1,
              pageCount: 1,
              con: con,
              cash: cash,
              searchList: [],
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        } else {
          //console.log('intReturn <> 0')
          this.setState({
            gotoPage: 1,
            pageCount: 1,
            con: con,
            cash: cash,
            dataList: [],
            hasMore: pageCount < gotoPage ? false : true,
          });
        }
      }
    }
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, authId } = this.props;

    return axios
      .post(apiUrl + '/myCash', {
        params: {
          userid: loginId,
          authId: authId,
          gotoPage: gotoPage,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _onItems = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  _renderItem = () => {
    const { dataList } = this.state;
    const list = dataList.map((item, index) => {
      return (
        <tr key={index}>
          <td>
            <span className={item.cash >= 0 ? 'color_2' : 'color_1'}>
              {item.cashFlag === 'A'
                ? '적립'
                : item.cashFlag === 'C'
                ? '충전'
                : item.cashFlag === 'M'
                ? '사용'
                : null}
            </span>
          </td>
          <td>{item.chargedDate}</td>
          <td>
            <div>
              {item.cashName}{' '}
              {item.title === '' ||
              item.title === null ||
              item.title === undefined ? null : (
                <span
                  style={{ color: 'orange', cursor: 'pointer' }}
                  onClick={() => this._onItems(item.contentSerial)}
                >
                  ({item.title}-{item.subTitle})
                </span>
              )}
            </div>
          </td>
          <td>{item.expiredDate}</td>
          <td>
            <span className={item.cash >= 0 ? 'color_2' : 'color_1'}>
              <NumberFormat
                displayType={'text'}
                value={item.cash}
                thousandSeparator={true}
              />
            </span>
          </td>
        </tr>
      );
    });

    return list;
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _onCardReg = () => {
    const { setCardRegShow } = this.props;
    setCardRegShow(true);
  };

  _onCardList = () => {
    const { setCardListShow } = this.props;
    setCardListShow(true);
  };
  _renderPage = () => {
    const { pageCount, gotoPage } = this.state;
    const pageNumbers = [];
    let blockPage = ((gotoPage - 1) / 10) * 10 + 1;
    let i = 0;
    ////console.log(blockPage, pageCount)
    do {
      pageNumbers.push(i);
      blockPage = blockPage + 1;
      i = i + 1;
    } while (i < 10 && i < pageCount);
    ////console.log(pageNumbers)
    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getData(num + 1)}
          className={gotoPage === num + 1 ? 'on' : null}
        >
          {num + 1}
        </span>
      );
    });

    return list;
  };
  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };
  render() {
    // const { tabIndex } = this.props.childProps;
    const { dataList, cash, pageCount } = this.state;
    return (
      <Fragment>
        <div className="mypage_content">
          <div className="mypage_group">
            <h1>
              포인트내역<span>({this._CommaFormatted(cash)}원)</span>
              <div style={{ position: 'absolute', right: 130 }}>
                <a style={{ cursor: 'pointer' }} onClick={this._onCardReg}>
                  카드등록
                </a>
              </div>
              <div>
                <a style={{ cursor: 'pointer' }} onClick={this._onCardList}>
                  나의카드
                </a>
              </div>
            </h1>
            <div className="my_table_list">
              <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                <colgroup>
                  <col width="9%" />
                  <col width="11%" />
                  <col width="" />
                  <col width="11%" />
                  <col width="13%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>구분</th>
                    <th>결제일시</th>
                    <th>사용내역</th>
                    <th>만료일</th>
                    <th>결제금액</th>
                  </tr>
                  {dataList ? this._renderItem() : null}
                </tbody>
              </table>

              <div className="page_no new_page">
                <span style={{ cursor: 'pointer' }} onClick={this._onPrev}>
                  이전
                </span>
                {pageCount > 0 ? (
                  this._renderPage()
                ) : (
                  <span style={{ cursor: 'pointer' }} className="on">
                    1
                  </span>
                )}
                <span style={{ cursor: 'pointer' }} onClick={this._onNext}>
                  다음
                </span>
              </div>
            </div>
          </div>
        </div>

        {/*카드 등록 */}

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyCash));
